/* @flow */

import invariant from 'invariant';

const loadScript = (url: string): Promise<void> => new Promise((resolve, reject) => {
    const { head } = document;
    invariant(head, `Não encontrou a head no documento portanto não foi possível importar o script ${url}`);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onreadystatechange = resolve;
    script.onload = resolve;
    script.onerror = reject;
    head.appendChild(script);
});

export default loadScript;
